var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import Form from 'react-jsonschema-form';
import InfoBanner from '../../components/info-banner';
import Popover from '../../components/popover';
import Thumbnail from '../../components/thumbnail';
import Button from '../button';
import Checkbox from '../checkbox';
import ColorPicker from '../color-picker';
import Dropdown from '../dropdown';
import Icon from '../icon';
import Input from '../input';
import DataSheetConfigField from './data-sheet-config';
import ExternalField from './external-field';
import popupHelper from './popup';
import { Styled } from './style';
var errorInfoBanner = function (errors) {
    var errorList = errors.map(function (error) { return React.createElement(InfoBanner, { description: error, color: "error", mini: true }); });
    return React.createElement("div", { className: "error-banner" }, errorList);
};
var helpTextPopover = function (helpText) { return helpText ?
    React.createElement("div", { className: "help-text" },
        React.createElement(Popover, { inverted: true, trigger: React.createElement(Icon, { name: "info" }), content: helpText, position: "top center" }))
    : null; };
var HiddenField = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("input", { disabled: props.disabled, type: "hidden", value: props.formData ? props.formData : props.schema.default }))); };
var ColorField = function (props) {
    var id = props.id, required = props.required;
    var options = props.uiSchema['ui:options'];
    var helpText = options ? options.helpText : '';
    var handleColorPickerCallback = function (color) {
        props.onChange(color.replace('#', ''));
    };
    var colorHex = props.formData ? '#' + props.formData : props.schema.default;
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "control-label", htmlFor: id },
            React.createElement("span", null,
                props.schema.title,
                " ",
                required ? '*' : null)),
        React.createElement("div", { className: "control-input" },
            React.createElement("div", { className: "control-input-field control-input-field__color" },
                helpTextPopover(helpText),
                React.createElement(ColorPicker, { disabled: props.disabled, color: colorHex, onComplete: handleColorPickerCallback })))));
};
/**
 * Used for the 2nd style of authentication
 * e.g. "Gallery for Business" <-- Currently the only app that uses this
 * i.e. type = "socialLogin" from old registry, i.e. old "social-login" component
 *
 * NB - Old "externalAppConfig" component is virtually the same logic? Used by Meet the Team.
 */
var SocialLoginField = function (props) {
    var id = props.id, required = props.required, formData = props.formData;
    var _a = props.schema, external_url = _a.external_url, popup_height = _a.popup_height, popup_width = _a.popup_width, initialValues = _a.initialValues;
    var formContext = props.registry.formContext;
    var handleExternalClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var auth, closePopup, appConfig;
        return __generator(this, function (_a) {
            event.preventDefault();
            auth = formContext && formContext.auth;
            if (!auth) {
                console.warn('Invalid form context auth given to create social login.');
                return [2 /*return*/];
            }
            closePopup = popupHelper.openPopup('about:blank', popup_width, popup_height, function (err, result) {
                if (err) {
                    console.log('error =', err);
                    return;
                }
                props.onChange(result);
            });
            appConfig = initialValues ? initialValues : {};
            auth.wrapAppConfig(appConfig).then(function (token) {
                if (!token) {
                    console.warn('Wrapping external config failed, no token returned.');
                    return;
                }
                var separator = external_url.indexOf('?') !== -1 ? '&' : '?';
                var encodedSeparator = external_url.indexOf('%3F') !== -1 ? '%26' : '%3F';
                var popupUrl = "" + external_url + encodedSeparator + "token=" + token + separator + "env=" + auth.environment;
                closePopup.popup.location.href = popupUrl;
            });
            return [2 /*return*/];
        });
    }); };
    // Do we have a valid value already?
    var hasValidValue = false;
    if (typeof formData === 'number' && formData >= 0) {
        hasValidValue = true;
    }
    else if (formData && formData.length > 1) {
        hasValidValue = true;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "control-label", htmlFor: id },
            React.createElement("span", null,
                props.schema.title,
                " ",
                required ? '*' : null)),
        React.createElement("div", { className: "control-input" },
            React.createElement("div", { className: "control-input-field control-input-field__social-login", style: { textAlign: 'left' } },
                React.createElement("input", { disabled: props.disabled, type: "hidden", defaultValue: props.formData && props.formData.length > 0 ? props.formData : props.schema.default, readOnly: true }),
                React.createElement(Button, { disabled: props.disabled, onClick: handleExternalClick, className: props.formData && props.formData.length > 1 ? 'success facebook-button' : 'facebook-button' },
                    React.createElement("svg", { width: "21", height: "21", id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 58 58" },
                        React.createElement("title", null, "f-ogo_RGB_HEX-58"),
                        React.createElement("path", { fill: "#fff", d: "M54.8,0H3.2A3.2,3.2,0,0,0,0,3.2V54.8A3.2,3.2,0,0,0,3.2,58H31V35.57H23.45V26.79H31V20.33c0-7.49,4.58-11.57,11.26-11.57A64.2,64.2,0,0,1,49,9.1v7.83h-4.6c-3.64,0-4.35,1.72-4.35,4.26v5.59h8.7l-1.13,8.78H40V58H54.8A3.2,3.2,0,0,0,58,54.8V3.2A3.2,3.2,0,0,0,54.8,0Z" }),
                        React.createElement("path", { fill: "#4267b2", id: "f", d: "M40,58V35.57h7.57l1.13-8.78H40V21.2c0-2.54.71-4.26,4.35-4.26H49V9.1a64.2,64.2,0,0,0-6.75-.34C35.56,8.76,31,12.84,31,20.33v6.46H23.45v8.78H31V58Z" })),
                    props.schema.button_text),
                hasValidValue ? (React.createElement(Icon, { name: "checked-circle", className: "facebook-success" })) : ('')))));
};
var ExternalAppLoginField = function (props) {
    var id = props.id, required = props.required, formData = props.formData;
    var _a = props.schema, external_url = _a.external_url, popup_height = _a.popup_height, popup_width = _a.popup_width, initialValues = _a.initialValues;
    var formContext = props.registry.formContext;
    var handleExternalClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var auth, closePopup, appConfig;
        return __generator(this, function (_a) {
            event.preventDefault();
            auth = formContext && formContext.auth;
            if (!auth) {
                console.warn('Invalid form context auth given to create external login.');
                return [2 /*return*/];
            }
            closePopup = popupHelper.openPopup('about:blank', popup_width, popup_height, function (err, result) {
                if (err) {
                    console.log('error =', err);
                    return;
                }
                props.onChange(result);
            });
            appConfig = initialValues ? initialValues : {};
            auth.wrapAppConfig(appConfig).then(function (token) {
                if (!token) {
                    console.warn('Wrapping external config failed, no token returned.');
                    return;
                }
                var separator = external_url.indexOf('?') !== -1 ? '&' : '?';
                var encodedSeparator = external_url.indexOf('%3F') !== -1 ? '%26' : '%3F';
                var popupUrl = "" + external_url + encodedSeparator + "token=" + token + separator + "env=" + auth.environment + separator + "source=studio";
                closePopup.popup.location.href = popupUrl;
            });
            return [2 /*return*/];
        });
    }); };
    // Do we have a valid value already?
    var hasValidValue = false;
    if (typeof formData === 'number' && formData >= 0) {
        hasValidValue = true;
    }
    else if (formData && formData.length > 1) {
        hasValidValue = true;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "control-label", htmlFor: id },
            React.createElement("span", null,
                props.schema.title,
                " ",
                required ? '*' : null)),
        React.createElement("div", { className: "control-input" },
            React.createElement("div", { className: "control-input-field control-input-field__external", style: { textAlign: 'left' } },
                React.createElement("input", { type: "hidden", defaultValue: formData && formData.length > 0 ? formData : props.schema.default, readOnly: true }),
                React.createElement(Button, { disabled: props.disabled, onClick: handleExternalClick, className: formData && formData.length > 1 ? ('success') : '' }, hasValidValue ? (React.createElement(React.Fragment, null,
                    React.createElement("span", null, "Logged In"),
                    React.createElement(Icon, { name: "checked-circle" }))) : (props.schema.button_text))))));
};
var CustomCheckbox = function (props) {
    var helpText = props.options.helpText;
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "control-label" },
            React.createElement("span", null, props.label)),
        React.createElement("div", { className: "control-input" },
            React.createElement("div", { className: "control-input-field" },
                helpTextPopover(helpText),
                React.createElement(Checkbox, { disabled: props.disabled, toggle: true, checked: props.value, onChange: function () { return props.onChange(!props.value); } })))));
};
var CustomInput = function (props) {
    var helpText = props.options.helpText;
    return (React.createElement("div", { className: "control-input" },
        React.createElement("div", { className: "control-input-field" },
            helpTextPopover(helpText),
            React.createElement(Input, { id: props.id, fluid: true, placeholder: props.schema.placeholder, value: props.value, disabled: props.disabled, onChange: function (event, data) { return props.onChange(data.value); }, required: props.required, onKeyDown: function (e) {
                    e.keyCode === 13 && e.preventDefault();
                } })),
        props.rawErrors && (errorInfoBanner(props.rawErrors))));
};
var CustomSelect = function (props) {
    var options = props.options.enumOptions.map(function (_a) {
        var label = _a.label, value = _a.value;
        return ({ key: value, value: value, text: label });
    });
    var helpText = props.options.helpText;
    return (React.createElement("div", { className: "control-input" },
        React.createElement("div", { className: "control-input-field" },
            helpTextPopover(helpText),
            React.createElement(Dropdown, { selection: true, placeholder: props.schema.default, fluid: true, options: options, disabled: props.disabled, onChange: function (event, data) { return props.onChange(data.value); }, value: props.value }))));
};
var CustomUpDown = function (props) {
    var helpText = props.options.helpText;
    return (React.createElement("div", { className: "control-input" },
        React.createElement("div", { className: "control-input-field control-input-field__updown" },
            helpTextPopover(helpText),
            React.createElement(Input, { id: props.id, type: "number", disabled: props.disabled, min: props.schema.minimum, max: props.schema.maximum, placeholder: props.schema.placeholder, value: props.value, onChange: function (event, data) { return props.onChange(data.value); }, required: props.required, onKeyDown: function (e) {
                    e.keyCode === 13 && e.preventDefault();
                } }))));
};
var wrapFile = function (file) { return ({
    _ref: {
        id: file.id,
        type: 'file',
        url: file.source,
        size: file.metadata.size,
    },
}); };
var MediaField = function (props) {
    var id = props.id, required = props.required;
    var openMediaPicker = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var result, file;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    return [4 /*yield*/, props.onRequestFiles({ mimeTypes: 'image/*', multiSelect: false })
                        // get the first result and wrap file into format app expects
                    ];
                case 1:
                    result = _a.sent();
                    // get the first result and wrap file into format app expects
                    if (result && result.media && result.media.length > 0) {
                        file = result.media[0];
                        props.onChange(wrapFile(file));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var removeImage = function (event) {
        event.preventDefault();
        props.onChange({});
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "control-label", htmlFor: id },
            React.createElement("span", null,
                props.schema.title,
                " ",
                required ? '*' : null)),
        props.formData._ref && props.formData._ref.url ?
            React.createElement("div", { className: "control-input" },
                React.createElement("div", { className: "control-input-field image" },
                    React.createElement("div", { className: "image-thumb", "data-testid": "image-thumbnail" },
                        React.createElement(Thumbnail, { size: "medium", src: props.formData._ref.url })),
                    React.createElement("div", { className: "image-remove" },
                        React.createElement(Button, { className: "button", disabled: props.disabled, onClick: removeImage }, "Remove"))))
            :
                React.createElement("div", { className: "control-input" },
                    React.createElement("div", { className: "control-input-field control-input-field__external", style: { textAlign: 'left' } },
                        React.createElement(Button, { disabled: props.disabled, onClick: openMediaPicker, className: "button" }, props.schema.button_text)))));
};
var CallOutText = function (props) { return React.createElement("p", { className: "call-out-text" }, props.schema.text); };
var InfoText = function (props) { return React.createElement("p", { className: "info-text" }, props.schema.text); };
var widgets = {
    CheckboxWidget: CustomCheckbox,
    TextWidget: CustomInput,
    SelectWidget: CustomSelect,
    UpDownWidget: CustomUpDown,
};
var fields = {
    hidden: HiddenField,
    colour: ColorField,
    external: ExternalField,
    socialLogin: SocialLoginField,
    externalAppLogin: ExternalAppLoginField,
    string: CustomInput,
    infoText: InfoText,
    callOutText: CallOutText,
    dataSheetConfig: DataSheetConfigField,
};
var JSONSchemaForm = /** @class */ (function (_super) {
    __extends(JSONSchemaForm, _super);
    function JSONSchemaForm(props) {
        var _this = _super.call(this, props) || this;
        _this.CreateMediaField = function (props) { return MediaField(__assign(__assign({}, props), { onRequestFiles: _this.props.onRequestFiles })); };
        return _this;
    }
    JSONSchemaForm.prototype.submit = function () {
        this.schemaForm.submit();
    };
    JSONSchemaForm.prototype.render = function () {
        var _this = this;
        return (React.createElement(Styled, { className: this.props.className },
            React.createElement(Form, __assign({}, this.props, { disabled: this.props.disabled, onError: this.props.onError, onSubmit: this.props.onSubmit, onChange: this.props.onChange, formData: this.props.formData, schema: this.props.schema, uiSchema: this.props.uiSchema, formContext: this.props.formContext, showErrorList: false, noHtml5Validate: true, widgets: widgets, fields: __assign(__assign({}, fields), { media: this.CreateMediaField }), ref: function (form) {
                    _this.schemaForm = form;
                } }), this.props.children)));
    };
    return JSONSchemaForm;
}(React.Component));
export default JSONSchemaForm;
//# sourceMappingURL=index.js.map